import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import {
  AddFolderButton,
  ConfirmationDialog,
  CustomTooltip,
  SmallScreenModel,
} from "components";
import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import { SuperAdminStatusEnum } from "../../props/enum";
import Loading from "layout/components/Loading";
import BreadcrumbFolderLayout from "modules/video/components/BreadcrumbFolderLayout";
import { CheyCheyImageProps } from "./store/actionType";
import { deleteCheyCheyImage, fetchCheyCheyImage } from "./store/action";
import CreateImage from "./page/CreateImage";
import { TrashIcon } from "assets";
import HandleDeleteImage from "./page/HandleDeleteImage";

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps;

const CheyChey: React.FC<Props> = ({
  onFetchCheyCheyImage,
  cheyCheyImageState,
  onDeleteImage,
}) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [deleteError, setDeleteError] = useState(null);
  const closeModal = () => {
    setModalOpen(false);
  };
  const imageId = cheyCheyImageState?.cheyCheyImage.map((item: any) =>
    item.id?.toString()
  );

  useEffect(() => {
    onFetchCheyCheyImage();
  }, []);
  const breadcrumbItem = [{ group: "Chey Chey", root: "Image" }];
  const { authUser, action, superAdmin } = useUser();

  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin ||
      action?.includes(Authorities.CREATE_GROUP));

  const handleDeleteGroup = (e: any) => {
    e.stopPropagation();
    onDeleteImage(imageId);
  };
  const toggleDeleteDialog = () => {
    setIsDeleteDialogOpen(!isDeleteDialogOpen);
  };
  useEffect(() => {
    setDeleteError(cheyCheyImageState.delete);
    if (cheyCheyImageState.delete === null) {
      setIsDeleteDialogOpen(false);
    }
  }, [cheyCheyImageState.delete]);
  return (
    <div className="h-full overflow-hidden">
      {cheyCheyImageState.isLoading && <Loading />}
      <BreadcrumbFolderLayout
        groupData={cheyCheyImageState?.avatarsImage}
        breadcrumbItem={breadcrumbItem}
        addFolderButton={
          <>
            {isPermitted && (
              <AddFolderButton
                onClick={() => {
                  setModalOpen(true);
                }}
              >
                Upload Image
              </AddFolderButton>
            )}
          </>
        }
        folders={
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {cheyCheyImageState?.cheyCheyImage &&
              cheyCheyImageState?.cheyCheyImage?.map(
                (imageData: CheyCheyImageProps) => (
                  <div key={imageData.id}>
                    <HandleDeleteImage
                      imageData={imageData}
                      onClick={function (): void {
                        throw new Error("Function not implemented.");
                      }}
                    />
                  </div>
                )
              )}
          </div>
        }
      />
      <SmallScreenModel showModal={isModalOpen} setShowModal={setModalOpen}>
        <CreateImage closeModal={closeModal} />
      </SmallScreenModel>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  cheyCheyImageState: state.cheyCheyImageReducer.cheyCheyImageState,
});

const mapDispatchToProps = (dispatch: any) => ({
  onFetchCheyCheyImage: () => dispatch(fetchCheyCheyImage()),
  onDeleteImage: (cheychey_id: string) =>
    dispatch(deleteCheyCheyImage(cheychey_id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CheyChey);
